/**
 * Composable that does a workaround to avoid implementing the anchor fragment navigation
 * Without losing any scroll smoothness and without placing the smooth scroll behavior globally
 */
export const useAnchorFragmentSmoothScroll = (scrollTarget: `#${string}`) => {
  const handleAnchorFragmentClick = () => {
    const htmlEl = document.documentElement
    htmlEl.style.scrollBehavior = 'smooth'
  }

  let originalScrollBehavior: string | null = null

  onMounted(() => {
    const anchorElement: HTMLAnchorElement | null = document.querySelector(`[href="${scrollTarget}"]`)
    if (!anchorElement) return

    const htmlEl = document.documentElement
    originalScrollBehavior = htmlEl.style.scrollBehavior

    anchorElement.addEventListener('click', handleAnchorFragmentClick)
  })

  onUnmounted(() => {
    const anchorElement: HTMLAnchorElement | null = document.querySelector(`[href="${scrollTarget}"]`)
    if (!anchorElement) return
    anchorElement.removeEventListener('click', handleAnchorFragmentClick)
    if (originalScrollBehavior) {
      const htmlEl = document.documentElement
      htmlEl.style.scrollBehavior = originalScrollBehavior
    }
  })
}
